module.exports = __webpack_public_path__ + "img/home.9527be0f.svg";